export const isGroup = (authority) => !!authority && authority.startsWith('GROUP_');
